import PropTypes from "prop-types";
import React, {Fragment, useEffect} from "react";
import {Modal} from "react-bootstrap";
import {connect} from "react-redux";
import ReactGA from "react-ga4";

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

function TokenSignInModal(props) {

  useEffect(() => {
    if (props.show) {
      if(window.location && window.location.pathname){
        let query = window.location.pathname
        if (window.location.search){
          query = query + window.location.search
        }
        console.log(query)
        localStorage.setItem('trc-client-token-sign-in-modal', JSON.stringify(query));
      }
      ReactGA.event({
        category: 'Modal',
        action: 'Open modal /sign-in/token-unavailable'});
    }
  }, [props.show])

  function handleClose() {
    window.location.href="/sign-in";
  }

  function handleCloseSignUp() {
    window.location.href="/sign-up";
  }

  return (
      <Fragment>
        <Modal
            size={"sm"}
            show={props.show}
            onHide={props.onHide}
            className="product-quickview-modal-wrapper"
        >
          <Modal.Header closeButton><h3>N'oubliez pas !</h3></Modal.Header>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <p>Pour utiliser cette fonctionnalité, il vous suffit de vous connecter !</p>
                </div>
                <br/>
                <div>
                  <div className="pro-details-quality col-md-6 col-sm-6 col-xs-6">
                    <div className="pro-details-cart btn-hover ml-0">
                      <button
                          style={{borderRadius: "10px", border: "3px solid black", backgroundColor: "#4fa0a6"}}
                          rel="noopener noreferrer"
                          onClick={() => handleClose()}
                      >
                        Me connecter
                      </button>
                    </div>
                    <div className="pro-details-cart btn-hover ml-0">
                      <button
                          style={{borderRadius: "10px",
                            backgroundColor: "white",
                            color: "black",
                            border: "3px solid black"}}
                          rel="noopener noreferrer"
                          onClick={() => handleCloseSignUp()}
                      >
                        Créer un compte
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
  );
}


TokenSignInModal.propTypes = {
  unavailableSizes: PropTypes.array,
  onHide: PropTypes.func,
  product: PropTypes.object,
  show: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    cartitems: state.cartData
  };
};

export default connect(mapStateToProps)(TokenSignInModal);